import { render, staticRenderFns } from "./MixByBudget.vue?vue&type=template&id=2a64bb66&"
import script from "./MixByBudget.vue?vue&type=script&lang=js&"
export * from "./MixByBudget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports